import { render, staticRenderFns } from "./FormResultError.vue?vue&type=template&id=60a2f0e0&"
import script from "./FormResultError.vue?vue&type=script&lang=ts&"
export * from "./FormResultError.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports